import type { StatDTO, StatDefinitionDTO, GameConfigurationDTO } from "../../shared/dtos";

export interface GameTextStyle {
    color: string;
    fontSize: string;
    fontFamily: string;
    stroke: string;
    strokeThickness: number;
    resolution: number;
}

export interface TextTheme {
    getColorString(path: string): string;
    getFontFamily(): string;
    getFontSize(size: string): string;
    getStrokeWidth(size: string): number;
}

export function buildTextStyle(
    theme: TextTheme,
    options?: {
        color?: string;
        fontSize?: string;
        resolution?: number;
    }
): GameTextStyle {
    return {
        color: options?.color ?? theme.getColorString("text.primary"),
        fontSize: options?.fontSize ?? theme.getFontSize("base"),
        fontFamily: theme.getFontFamily(),
        stroke: theme.getColorString("ui.backgroundDark"),
        strokeThickness: theme.getStrokeWidth("normal"),
        resolution: options?.resolution ?? 2,
    };
}

export function buildStatText(
    label: StatDefinitionDTO | undefined,
    stat: StatDTO | undefined,
    secondaryStat?: StatDTO | undefined
): string | null {
    if (!label || stat?.value == null) return null;
    if (secondaryStat !== undefined && secondaryStat.value == null) return null;
    if (secondaryStat !== undefined) {
        return `${label.name} : ${stat.value}/${secondaryStat.value}`;
    }
    return `${label.name}: ${stat.value}`;
}

export function calculateRequiredXP(
    currentLevel: number,
    gameConfig: GameConfigurationDTO
): number {
    const nextLevel = currentLevel + 1;
    if (gameConfig.stat_grids?.xp_grid) {
        return gameConfig.stat_grids.xp_grid.get_required_xp(nextLevel);
    }
    return nextLevel * 100;
}
